import { createToastQueue } from "ui-kit";

export default createToastQueue({ maxVisibleToasts: 5, hasExitAnimation: true });
